import { isStoragePath } from "@/lib/mediaStorage";
import type { GalleryItem } from "@/lib/adminContent";

/**
 * Compact gallery indicator for admin list rows: a thumbnail of the first photo
 * plus a count badge. Storage-path images are resolved through the supplied
 * signed-URL map.
 */
export function GalleryCell({
  items,
  pathMap,
}: {
  items: GalleryItem[] | null | undefined;
  pathMap: Record<string, string>;
}) {
  const list = items || [];
  if (list.length === 0) {
    return <span className="text-xs text-foreground-400">—</span>;
  }

  const first = list[0];
  const url = isStoragePath(first.src) ? pathMap[first.src] : first.src;

  return (
    <div className="flex items-center gap-2">
      <span className="w-9 h-9 rounded-md overflow-hidden bg-background-100 border border-background-200 flex items-center justify-center text-foreground-400 shrink-0">
        {url ? (
          <img
            src={url}
            alt={first.alt || "Gallery thumbnail"}
            className="w-full h-full object-cover object-top"
          />
        ) : (
          <i className="ri-image-line"></i>
        )}
      </span>
      <span className="inline-flex items-center gap-1 text-xs font-semibold text-secondary-700 bg-secondary-100 border border-secondary-200 px-2 py-0.5 rounded-full whitespace-nowrap">
        <i className="ri-gallery-line"></i> {list.length}
      </span>
    </div>
  );
}